/**
 * Utility function
 */
define('atn/utils',['durandal/app', 'durandal/system', 'lodash',
        'jquery', 'plugins/router', 'knockout', 'moment', './config',
        'common/utils', 'customPlugins/utils'
    ],
    function(app, system, _, $, rootRouter, ko, moment, config, commonUtils, pluginUtils) {
        'use strict';
        var utils = _.clone(commonUtils);
        _.assign(utils, pluginUtils);
        /**
         * utility function to extract error from jQuery xhr
         * @param  {jquery.xhr} xhr xhr object from jquery response
         * @return {object}     error object containing status and message
         */
        utils.extractError = function(xhr) {
            var error = {
                status: xhr.status,
                message: {
                    __unknown: [xhr.statusText]
                }
            };

            if (!xhr.readyState && config.ajaxTimeoutStatusText === xhr.statusText) {
                error.message.__unknown = [config.timeoutMessage];
            } else if (xhr.responseJSON) {
                try {
                    var apiError = utils.getApiErrorObject(xhr.responseJSON);
                    if (_.isObject(apiError)) {
                        error.message = apiError;
                    } else {
                        error.message = JSON.parse(apiError);
                    }
                } catch (e) {
                    error.message = {
                        __unknown: utils.getApiErrorObject(xhr.responseJSON)
                    };
                }
            }

            return error;
        };
        //  extracts error object from responseJSON
        utils.getApiErrorObject = function(responseJSON) {
            var apiError = {};
            //  check weather if apiError is there
            if (responseJSON && responseJSON.message) {
                //  in case apiError is there
                apiError = responseJSON.message;
            }
            return apiError;
        };
        
        utils.createComputedError = function(errorObs, keys, nestedKeysList) {
            var error = {};
            _.forEach(keys, function(key) {
                error[key] = ko.computed({
                    read: function() {
                        var errorMessage;
                        //this if condition is always true when any error is returned from API;It will not be called
                        //the first time the computed error object is created;i.e. at initialization.
                        if (_.isArray(errorObs()[key])) {
                            if (_.isArray(errorObs()[key][0])) {
                                //return array of observables.The array returned will be made observable by computed.
                                errorMessage = [];
                                _.forEach(errorObs()[key][0], function(err) {
                                    var localErrorObj = {};
                                    _.forEach(err, function(errValue, errKey) {
                                        localErrorObj[errKey] = ko.observable(errValue[0]);
                                    });
                                    errorMessage.push(localErrorObj);
                                });
                            } else {
                                //return simple string which will be made observable by computed.
                                errorMessage = errorObs()[key][0];
                            }
                        }
                        //this else if is called at initialization of the error object from
                        //the JSON errorObservable(returned in $.fail xhr object).it is used to
                        //initialize error object for fields with nested errors.Only a single entry(observable) is
                        //created at the new level because we do not know all entries at initialization.
                        else if (_.indexOf(nestedKeysList, key) >= 0) {
                            var localErrorObj = {};
                            errorMessage = [localErrorObj];
                        }
                        //this else if is called at initialization of the error object for simple(single level)
                        //form error fields.simple string.
                        else {
                            errorMessage = '';
                        }
                        return errorMessage;
                    },
                    deferEvaluation: true
                });
            });
            error.__global = ko.computed({
                read: function() {
                    return _.flatten(_.values(_.filter(errorObs(), function(val, key) {
                        return (_.indexOf(keys, key) < 0);
                    })));
                },
                deferEvaluation: true
            });
            return error;
        };
        utils.createDropDownReadFn = function(parentObservable, key) {
            return function() {
                return _.map((parentObservable())[key], function(value, key) {
                    return {
                        id: key,
                        text: value()
                    };
                });
            };
        };
        utils.getFileFromInput = function(event, element, cleanup) {
            event.stopPropagation();
            //  fetching first file
            var file = element.files[0];
            //  cleaning up
            if (cleanup) {
                element.value = utils.isInternetExplorer() ? undefined : null;
            }
            return file;
        };
        utils.randomAlphanumericLowercase = function(length) {
            // For the sake of consistency,
            // the following alphanumeric set should match with the set used in GuestbookUsersController.php in the API.
            var chars = '0123456789abcdefghijkkllmnopqrrsstuvwxyz',
                charsLength = chars.length - 1;
            var randomChars = '';
            for (var x = 0; x < length; x++) {
                var i = Math.floor(Math.random() * charsLength);
                randomChars += chars.charAt(i);
            }
            return randomChars;
        };

        /**loadFavicon: load the favicon after the brand is available.
         *@param brand: the object that contains the brand-specific strings.
        */
        utils.loadFavicon = function (faviconPath, uiVersionQueryObj) {
            var link = document.createElement('link');
            link.type = 'image/png';
            link.rel = 'icon';
            link.href = utils.createURL(
                faviconPath,
                uiVersionQueryObj
            );
            document.getElementsByTagName('head')[0].appendChild(link);
        };


        utils.sum = function(collection) {
            return _.reduce(collection, function(sum, n) {
                return sum + n;
            }, 0);
        };

        /**
         * [dateToFormattedString converts javascript dateObj to different string formats]
         * @param  {[dateObject]} dateObj      [Javascript Date Object]
         * @param  {[boolean]} milliSecsReq [flag to check if the return string format contains millisecs precision]
         * @return {[string]}              [description]
         */
        utils.dateToFormattedString = function(dateObj, milliSecsReq) {
            var retDateStr = '';
            if(dateObj){
                if (milliSecsReq) {
                    retDateStr = moment(dateObj).format(config.dateFormatStringMsecs);
                } else {
                    retDateStr = moment(dateObj).format(config.dateFormatString);
                }
            } else{
                retDateStr = 'N/A';
            }
            return retDateStr;
        };

        utils.utcToLocal = function(utcDate) {
            return moment.utc(utcDate, config.dateFormatStringMsecs).local().format(config.dateFormatStringAmPm);
        };
        utils.utcToDate = function(utcDate) {
            return moment.utc(utcDate, config.dateFormatStringMsecs).local()._d;
        };
        /**
         * [localDateToUTC converts input dateObj to different string formats]
         * @param  {[date]} date      [Date Object]
         * @param  {[boolean]} noMillis [flag to check if the return string format contains millisecs precision]
         * @param  {[string]} timezone_offset [the timezone to use as offset to subtract for getting UTC time]
         * if timezone is undefined then local/machine timezone will be used to calculate UTC time.
         * @return {[string]}              [description]
         *
         */
        utils.localDateToUTC = function(date, noMillis, timezone_offset) {
            var dateStr, dateFormatStr;
            if (noMillis) {
                dateFormatStr = config.dateFormatString;

            } else {
                dateFormatStr = config.dateFormatStringMsecs;
            }
            if (timezone_offset) {
                dateStr = moment(date).subtract(utils.convertHoursToSeconds(timezone_offset), 's').format(dateFormatStr);
            } else {
                dateStr = moment(date).utc().format(dateFormatStr);
            }
            return dateStr;
        };

        utils.getMomentObject = function(date) {
            return moment(date);
        };

        /**
         * [convertUTCToOffsetAndFormat Offsets the given 'utcTime' according to the supplied 'timezone_offset' and
         * returns the result in specified 'returnStringFormat' and optionally 'split' the time and return  date time seperately or
         * return the whole date-time as a string or if 'returnAsString' is set along with split return  as a space delimited date-time string.]
         * @param  {String} utcTime            [the base time string to apply offset to]
         * @param  {String} timezone_offset    [the timezone/offset to apply to the base time string]
         * @param  {String} returnStringFormat [the format of the date to return eg 'MM DD YYYY HH:mm:tt']
         * @param  {Boolean} split              [split date time as return object or delimit with space]
         * @param  {Boolean} returnAsString     [split the date time and return as a string with space delimited date-time]
         * @return {Object|String}                    [the custom object or string ]
         */
        utils.convertUTCToOffsetAndFormat = function(utcTime, timezone_offset, returnStringFormat, split, returnAsString) {
            var dateObj, modifiedDateObj, utcMilliSeconds, timeFormatArray, retVal, returnObj = {};
            returnObj.dateFragment = '';
            returnObj.timeFragment = '';

            if (!utcTime) {
                if (split && returnAsString) {
                    retVal = [returnObj.dateFragment, returnObj.timeFragment].join(' ');
                } else if (split && !returnAsString) {
                    retVal = returnObj;
                } else {
                    retVal = 'N/A';
                }
                return retVal;
            }

            //create Date object for current location
            dateObj = moment(utcTime);
            //convert to msec add local time zone offset get UTC time in msec
            utcMilliSeconds = dateObj.valueOf();
            //create new Date object for different city using supplied offset
            modifiedDateObj = moment(utcMilliSeconds + (1000 * utils.convertHoursToSeconds(timezone_offset)));
            //if date returned needs to be split into date fragments and timeFragments
            if (split) {
                returnObj = {};
                timeFormatArray = returnStringFormat.split(/\s{1,}/g);
                returnObj.dateFragment = modifiedDateObj.format(timeFormatArray.slice(0, 3).join(' '));
                returnObj.timeFragment = modifiedDateObj.format(timeFormatArray.slice(3, timeFormatArray.length).join(' '));
                //if we want a string to be returned instead of object.
                if (returnAsString) {
                    returnObj = [returnObj.dateFragment, returnObj.timeFragment].join(' ');
                }
            }
            //return time as a string if splitting date and time is not required
            else {
                returnObj = modifiedDateObj.format(returnStringFormat);
            }
            return returnObj;
        };

        utils.convertHoursToSeconds = function(hours) {

            if (_.isNumber(hours)) {
                return hours * 60 * 60;
            }
            //if there is any issue from field then please uncomment this.
            var signum = 1;
            if (_.isString(hours)) {
                signum = (hours.match('^-.*')) ? -1 : 1;
                hours = hours.replace('+', '').replace('-', '').split(':');
                hours = parseInt(hours[0], 10) + parseInt(hours[1], 10) / 60;
                return signum * hours * 60 * 60;
            } else {
                return 0;
            }
        };
        utils.convertMilliSecsToTzOffsetStr = function(millisecs) {
            var retStr = '';
            var hours = millisecs/(3600*1000);
            if(hours>0){
                retStr += '+';
            }
            var mins = Math.abs((hours % 1)*60);
            retStr += parseInt(hours);
            retStr += ':';
            retStr += mins?mins:'00';
            return retStr;
        };
        /**
         * [translateRemoteTzToLocalTz converts param value 'javascriptDate' time to utc epoch assuming the timezone is function 
         * argument value 'timezoneOffset']
         * @param  {Object} javascriptDate [the javascript Date primitive; the selected date in the widget]
         * @param  {Number} timezoneOffset [the timezone offset in milliseconds of the timezone to time travel to]
         * @return {Number}                [utc epoch wrt timezoneOffset value passed as the argument]
         */
        utils.translateUtcFromRemoteTzToLocalTz = function(javascriptDate, timezoneOffset){
            var selectedDateEpoch = moment(javascriptDate).valueOf();
            var differenceToSubtract = utils.getTimeDiffInMs(javascriptDate, timezoneOffset, selectedDateEpoch);
            return moment(selectedDateEpoch - differenceToSubtract)._d;
        };

        utils.translateLocalToEpochWrtRemoteTz = function(javascriptDate, timezoneOffset){
            var selectedDateEpoch = moment(javascriptDate).valueOf();
            var differenceToAdd = utils.getTimeDiffInMs(javascriptDate, timezoneOffset, selectedDateEpoch);
            return selectedDateEpoch + differenceToAdd;
        };

        utils.getTimeDiffInMs = function(javascriptDate, timezoneOffset, selectedDateEpoch){
            var difference;
            //since offset got is in minutes with respect to UTC, it has opposite sign.So convert it wrt local tz.
            //verify in javascript console to understand this properly.
            var machineTzOffset = (-1) * moment(javascriptDate).zone() * 60 * 1000;
            var difference = machineTzOffset - timezoneOffset;
            return difference;
        };

        utils.sformat = function(format) {
            var args = Array.prototype.slice.call(arguments, 1);
            return format.replace(/{(\d+)}/g, function(match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        };
        utils.dummySuccessDeferred = function(response) {
            var deferred = $.Deferred();
            _.defer(deferred.resolve, response);
            return deferred.promise();
        };
        utils.dummyFailedDeferred = function(response) {
            var deferred = $.Deferred();
            _.defer(deferred.reject, response);
            return deferred.promise();
        };

        /**
         * Check if given string is unicode or not.
         * @param str - input string to check for unicode.
         * @returns {boolean}
         */
        utils.isUnicode = function(str) {
            /*
                Converting the string to utf-8 and replacing %20 with spaces from given utf-8 string.
             */
            var xaxisLabel = encodeURIComponent(str).replace(/%20/g, ' ');
            //check if there are still any % occurrences in the string.
            //if occurrences are present then it is a unicode.
            if (xaxisLabel.indexOf('%') > -1) {
                return true;
            } else {
                return false;
            }
        };

        /**
         * This function is used to generate xaxis data for location based charts
         */
        utils.generateXaxisLocationData = function(locationName, flag) {
            var truncateLocName,
                lengthValue = (locationName.toString() || '').length;

            if (utils.isUnicode(locationName)) {
                truncateLocName = '<div style="margin-right: 54px;" title="' + locationName + '">...' + (locationName.substring(lengthValue - 5)) + '</div>';
            } else {
                switch (true) {
                    case (lengthValue < 5):
                        truncateLocName = '<div style="margin-right: ' + (lengthValue + 20) + 'px;">' + locationName + '</div>';
                        break;
                    case (lengthValue >= 5 && lengthValue <= 10):
                        truncateLocName = '<div style="margin-right: ' + (lengthValue + 40) + 'px;">' + locationName + '</div>';
                        break;
                    case (lengthValue > 10):
                        if (flag) {
                            // if flag is true then add ellipsis at the end of string (e.g for Showrooming Domains chart)
                            truncateLocName = '<div style="margin-right: 54px;" title="' + locationName + '">' + (locationName.substring(0, 10)) + '...' + '</div>';
                        } else {
                            // if flag is false or not provided then ellipsis will be added to start of string (e.g for all Locations chart in Analytics)
                            truncateLocName = '<div style="margin-right: 54px;" title="' + locationName + '">...' + (locationName.substring(lengthValue - 10)) + '</div>';
                        }
                        break;
                }
            }
            return truncateLocName;
        };

        utils.filterGuestbookPortals = function(portalList) {
            return _.filter(portalList, function(portal) {
                return portal.active() && !!(_.find(portal.plugins_selected(), function(plugin) {
                    return plugin.pgid() === config.plugins.GUESTBOOK;
                }));
            }) || [];
        };

        utils.getDataTransferFromData = function(model, unit) {
            var dataTransferFrom = [];
            _.each(model.data_transfer_from, function(value) {
                dataTransferFrom.push(parseFloat((value / unit).toFixed(2)));
            });
            return dataTransferFrom;
        };

        utils.getDataTransferToData = function(model, unit) {
            var dataTransferTo = [];
            _.each(model.data_transfer_to, function(value) {
                dataTransferTo.push(parseFloat((value / unit).toFixed(2)));
            });
            return dataTransferTo;
        };

        utils.getUnits = function(max, yValue, unitObject, baseUnit, roundOff) {
            var yAxisUnit;
            if(baseUnit === 'KB'){
                yAxisUnit = [{
                    denomination: '(PB)',
                    value: 1024 * 1024 * 1024 * 1024
                }, {
                    denomination: '(TB)',
                    value: 1024 * 1024 * 1024
                }, {
                    denomination: '(GB)',
                    value: 1024 * 1024
                }, {
                    denomination: '(MB)',
                    value: 1024
                }, {
                    denomination: '('+ baseUnit + ')',
                    value: 1
                }];
            } else {
                yAxisUnit = [{
                denomination: '(Trillions)',
                value: 1000000000000
                }, {
                    denomination: '(Billions)',
                    value: 1000000000
                }, {
                    denomination: '(Millions)',
                    value: 1000000
                }, {
                    denomination: '(Thousands)',
                    value: 1000
                }, {
                    denomination: '',
                    value: 1
                }];
            }

            
            if (!_.isEmpty(unitObject)) {
                var divisor = _.find(yAxisUnit, {
                    denomination: unitObject.unit
                }).value;
                unitObject.value = yValue / divisor;
            } else {
                _.forEach(yAxisUnit, function(object) {
                    if (max >= object.value) {
                        unitObject.unit = object.denomination;
                        unitObject.value = (yValue / object.value);
                        return false;
                    } else {
                        unitObject.unit = '';
                        unitObject.value = yValue;
                    }
                });
            }

            if(roundOff){
                unitObject.value = Math.round(unitObject.value);
            }

            return unitObject;
        };

        /**
         * convert integer value to proper format e.g. 2K, 5M
         * @param  {[type]} value [description]
         * @return {[type]}       [description]
         */
        utils.getDashboardUnits = function(value) {
            var unitObject = {};
            var unitsArray = [{
                denomination: 'T',
                value: 1000000000000
            }, {
                denomination: 'B',
                value: 1000000000
            }, {
                denomination: 'M',
                value: 1000000
            }, {
                denomination: 'K',
                value: 1000
            }, {
                denomination: '',
                value: 1
            }];
            _.each(unitsArray, function(object) {
                if (value >= object.value) {
                    unitObject.unit = object.denomination;
                    unitObject.value = value / object.value;
                    unitObject.multiplier = object.value;
                    if (object.denomination) {
                        unitObject.value = unitObject.value.toFixed(2);
                    }
                    return false;
                } else {
                    unitObject.unit = '';
                    unitObject.value = String(value);
                    unitObject.multiplier = 1;
                }
            });
            return unitObject;
        };

        /**
         * to generate percentage change string for dashboard. The values are taken absolute
         * For eg: -12345            = 12.34K
         *          -123456789       = 12.34M
         * @param  {Number|String} percentageChange  Percentage change or number converatable percentage string like "-123456"
         * @return {String}                          Percentage change string that has to be shown on dashboard
         */
        utils.getDashboardPercentChangeString = function(percentageChange) {
            var result;
            if (percentageChange === '--' || percentageChange === '0') {
                result = percentageChange;
            } else {
                var percentChangeUnits = utils.getDashboardUnits(Math.abs(percentageChange));
                result = percentChangeUnits.value + percentChangeUnits.unit;
            }
            return result;
        };

        /**
         * function to calculate percentage for each object element, ignoring the supplied key
         * @param  {[type]} data      [description]
         * @param  {[type]} ignoreKey [description]
         * @return {[type]}           [description]
         */
        utils.calculatePercentIgnoreKey = function(data, ignoreKey) {

            var total; // sum of all values of the object's immediate keys
            var percentValue = {}; //object finally returned by this function
            // calculate sum of all values 
            total = _.reduce(data, function(sum, keyValue, keyName) {
                if (keyName !== ignoreKey) {
                    sum = sum + keyValue;
                }
                return sum;
            });
            if (total > 0) {
                percentValue = _.reduce(data, function(result, keyValue, keyName) {
                    if (keyName !== ignoreKey) {
                        // ignore calculating percent for key 
                        result.push(Math.round(((keyValue * 100) / total)).toString());
                    }
                    return result;
                }, []);
            } else {
                percentValue = _.reduce(data, function(result, keyValue, keyName) {
                    if (keyName !== ignoreKey) {
                        // ignore calculating percent for key 
                        result.push('--');
                    }
                    return result;
                }, []);
            }
            return percentValue;
        };

        /**
         * calculate percentage for each element of given javascript object and optional key string
         * @param  {JS object} data
         * @param  {string} totalKey
         */
        utils.calculateObjectPercent = function(data, totalKey) {

            var total; // sum of all values of the object's immediate keys
            var percentValue = {}; //object finally returned by this function
            if (_.has(data, totalKey)) {
                total = data[totalKey];
            } else {
                // calculate sum of all values 
                total = utils.calculateSum(data);
            }
            if (total > 0) {
                percentValue = _.reduce(data, function(result, keyValue, keyName) {
                    if (keyName !== totalKey) {
                        // ignore calculating percent for key 
                        result.push(Math.round((keyValue * 100) / total).toString());
                    }
                    return result;
                }, []);
            } else {
                percentValue = _.reduce(data, function(result, keyValue, keyName) {
                    if (keyName !== totalKey) {
                        // ignore calculating percent for key 
                        result.push('--');

                    }
                    return result;
                }, []);
            }
            return percentValue;
        };

        /**
         * Preliminary percent calculation operation for non-zero denominator
         * @param   value [description]
         * @param   total [description]
         */
        utils.percent = function(value, total) {
            if (total > 0) {
                return Math.round((value * 100) / total).toString();
            } else {
                return '&#8208; &#8208;';
            }
        };
        utils.percentChange = function(newValue, oldValue) {
            /**
             * Comparing old and new value is greater than 0.005 or not.
             * Description: 1. Some values in the widgets are less than 0.005 and percentage change is calculated with these numbers which are very small compared to total amount of users.
             * 2. So, if the numbers are greater than or equal to 0.005 then percentage change will be greater than or equal to 1 (after rounding the number).
             * 3. So, user can now understand the calculated number which is displayed on UI.
             *
             */
            if ((oldValue >= 0.005 || newValue >= 0.005) && (oldValue !== 0)) {
                return (Math.round(((newValue - oldValue) * 100) / oldValue)).toString();
            } else {
                return '--';
            }
        };

        /**
         * Calculate sum of all keyvalues in given data
         * @param  {collection} data
         */
        utils.calculateSum = function(data) {
            return _.reduce(data, function(sum, keyValue) {
                return sum + keyValue;
            });
        };

        /**
         * [convertHyphenToCamelCase converts the given string by removing hyphens and replacing the next substring into upper case.]
         * @param  {[string]} stringName [name of the string]
         * @return {[type]}            [description]
         * Payal---This function does not handle some cases written in utilsSpec.js in tests folder
         * this function need to be changed.
         * Also there is a function for same in lodash i.e. "_.camelCase"
         */
        utils.convertHyphenToCamelCase = function(stringName) {
            return stringName.toLowerCase().replace(/-(.)/g, function(match, subString) {
                return subString.toUpperCase();
            });
        };
        /**
         * This function returns true if passed string is json else it returns false
         */
        utils.isJsonString = function(jsonString) {
            try {
                if (jsonString === '') {
                    return true;
                }
                JSON.parse(jsonString);
            } catch (e) {
                return false;
            }
            return true;
        };

        /**
         * function to synchronously load CSS into document
         * @param  {String} src     URL of the CSS source
         * @param  {DOMElement} doc Reference to the document of the window
         * @return {undefined}
         */
        utils.syncLoadCss = function(src, doc) {
            doc = doc || document;
            var style = doc.createElement('LINK');
            style.rel = 'stylesheet';
            style.href = src;
            doc.head.appendChild(style);
        };

        utils.getIFrameDocument = function(iframe) {
            var iframeWindow = utils.getIFrameWindow(iframe);
            return iframeWindow.document ? iframeWindow.document : iframeWindow;
        };

        utils.getIFrameWindow = function(iframe) {
            return iframe.contentWindow || iframe.contentDocument;
        };

        utils.replaceKeys = function(str, map) {
            var string = String(str);
            _.forOwn(map, function(value, key) {
                var regex = new RegExp('{' + key + '}', 'g');
                string = string.replace(regex, String(value));
            });
            return string;
        };

        /**
         * function to compare two string
         * @param  {String} string1 first string
         * @param  {String} string2 Second string
         * @return {Number}         -1 if string2 is greater, 1 if string1 is greater otherwise 0
         */
        utils.compareStrings = function(string1, string2) {
            var retValue;
            if (string1 === string2) {
                retValue = 0;
            } else if (string1 > string2) {
                retValue = 1;
            } else {
                retValue = -1;
            }
            return retValue;
        };
        /**
         * function to create the data for limiting devices kendoDropDown box for plugin configuration.
         * @return {object} the array of objects in {display:'some text',value:'some text'} format
         */
        utils.calculateDeviceLimitValues = function() {
            var returnValue = [{
                display: 'N/A',
                value: null
            }];
            var maxLimit = 10;
            for (var i = 1; i <= maxLimit; i++) {
                returnValue.push({
                    display: '' + i,
                    value: i
                });
            }
            return returnValue;
        };

        /**
         * to freeze an object recursively
         * @param  {Object} freezingObject Object to be frozen
         * @return {undefined}
         */
        utils.deepFreeze = function(freezingObject) {
            var prop, propKey;
            Object.freeze(freezingObject); // First freeze the object.
            for (propKey in freezingObject) {
                prop = freezingObject[propKey];
                if (!(freezingObject.hasOwnProperty(propKey)) || typeof prop != 'object' || Object.isFrozen(prop)) {
                    // If the object is on the prototype, not an object, or is already frozen,
                    // skip it. Note that this might leave an unfrozen reference somewhere in the
                    // object if there is an already frozen object containing an unfrozen object.
                    continue;
                }
                utils.deepFreeze(prop); // Recursively call deepFreeze.
            }
        };

        /**
         * converts circle created by css to circle png using canvas
         * @param  {DOMElement} element The circle element itself
         * @return {undefined}
         */
        utils.cssCircleToPng = function(element) {
            var canvas = document.createElement('CANVAS'),
                size = parseInt(utils.getStyle(element, 'width') || '0', 10),
                center = size / 2,
                radius = size / 2,
                context = canvas.getContext('2d');
            canvas.width = canvas.height = size;
            context.fillStyle = '#fff';
            context.fillRect(0, 0, size, size);
            context.beginPath();
            context.arc(center, center, radius, 0, 2 * Math.PI, true);
            context.fillStyle = utils.getStyle(element, 'background-color') || '#fff';
            context.fill();
            element.style.backgroundImage = 'url(' + canvas.toDataURL('image/png') + ')';
        };

        /**
         * to get the css property of an element
         * @param  {DOMElement} element   the element whose css property has to be investigated
         * @param  {String} styleProp     name of the property itself
         * @return {String}               The value of the property itself else undefined
         */
        utils.getStyle = function(element, styleProp) {
            var value;
            if (element.currentStyle) {
                value = element.currentStyle[styleProp];
            } else if (window.getComputedStyle) {
                value = document.defaultView.getComputedStyle(element, null).getPropertyValue(styleProp);
            }
            return value;
        };

        /**
         * function to perform unitary method
         *
         * The unitary method is a technique in elementary algebra
         * for solving a class of problems in variation. It consists
         * of altering one of the variables to a single unit, i.e. 1,
         * and then performing the operation necessary to alter it to
         * the desired value
         *
         * Here we use the equestion,
         *
         * total value of current unit    total value of other unit
         * --------------------------- =  -------------------------
         * number of current unit         number of other units
         *
         * @param  {Number} otherNum  total value of other unit
         * @param  {Number} otherDeno number of other units
         * @param  {Number} selfDeno  number of current unit
         * @return {Number}           total value of current unit
         */
        utils.unitary = function(otherNum, otherDeno, selfDeno) {
            return (otherNum * selfDeno) / otherDeno;
        };

        /**
         * to convert radian to degree
         * @param  {Number} angleRad Angle in Radian
         * @return {Number}          Angle in Degree
         */
        utils.rad2deg = function(angleRad) {
            return (angleRad * 180) / Math.PI;
        };

        /**
         * to extract the id (node_type, server_id, location_id) out of the given location node
         * @param  {Object} locationNode Given location node
         * @return {Object}              id (node_type, server_id, location_id) for location
         */
        utils.extractLocationNodeId = function(locationNode) {
            return {
                node_type: locationNode.node_type,
                server_id: locationNode.server_id || 'null',
                location_id: locationNode.location_id,
            };
        };

        /**
         * This function returns the key value pair of display and value of day/hour categories
         * @return {[array]} key value pair of display and value
         */
        utils.getDayHourCategories = function() {
            return [{
                display: 'Days',
                value: 'days'
            }, {
                display: 'Hours',
                value: 'hours'
            }];
        };

        utils.createImage = function(url) {
            var image = new Image();
            image.src = url;
            return image;
        };

        utils.b64toBlob = function(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {
                type: contentType
            });
            return blob;
        };

        /**
         * [findInObjectArray: search for the needle in the haystack.
         *     The needle may or may-not-be found.
         *     The haystack is an aray of objects.]
         * @param  {string|number|null} needle  [a number or string as the key to compare in the object]
         * @param  {[array of objects]} haystackObjectArray [array of objects to search.]
         * @param  {[string]} keyToMatch          [the object member name where the key should be searched.]
         * @return {[object]}  [ On success, return the object where the object member matches the specified needle.
         *                       On failure, return undefined.]
         */
        utils.findInObjectArray = function(needle, haystackObjectArray, keyToMatch, whenNoMatchValKey) {
            var returnValue, id, totalLength, totalDigits, itemToMatch;

            needle = ko.utils.unwrapObservable(needle);
            haystackObjectArray = ko.utils.unwrapObservable(haystackObjectArray);

            if (_.isString(needle) && needle.length) {
                totalLength = needle.match(/[\d\D]/g).length ? needle.match(/[\d\D]/g).length : 0;
                totalDigits = needle.match(/[\d]/g) ? needle.match(/[\d]/g).length : 0;

                if (totalLength === totalDigits) {
                    id = parseInt(needle, 10);
                } else {
                    id = needle;
                }
            } else if (_.isNumber(needle)) {
                id = needle;
            } else if (!(_.isString(needle))) {
                id = null;
            } else {
                id = '';
            }

            returnValue = _.find(haystackObjectArray, function(singleObject) {
                if (totalLength && totalDigits && (totalLength === totalDigits)) {
                    itemToMatch = parseInt(ko.utils.unwrapObservable(singleObject[keyToMatch]), 10);
                } else {
                    itemToMatch = ko.utils.unwrapObservable(singleObject[keyToMatch]);
                }
                return itemToMatch === id;
            });
            
            if(whenNoMatchValKey && !returnValue) {
                returnValue = {};
                returnValue[keyToMatch] = '';
                returnValue[whenNoMatchValKey] = '';
            }

            return returnValue;
        };

        /**
         * [getShortLocationPath Converts the full location path array to shortened location/sublocation format]
         * @param  {Array} scheduleLocationArray [array containing thefull location path]
         * @return {String}                       [Stringified shortened location in location/sublocation format]
         */
        utils.getShortLocationPath = function(scheduleLocationArray) {
            var locationPath;
            if (!scheduleLocationArray || (scheduleLocationArray.length === 0)) {
                locationPath = config.messages.reporting.location_not_exists;
            } else if (scheduleLocationArray.length > 1) {
                locationPath = scheduleLocationArray[scheduleLocationArray.length - 2] + ' / ' + scheduleLocationArray[scheduleLocationArray.length - 1];
            } else {
                locationPath = scheduleLocationArray[scheduleLocationArray.length - 1];
            }
            return locationPath;
        };

        /**
         * [getTextFromValue finds and returns the text of the given needle id from an array of text-id key value pairs.
         * eg. Finds the 'value' corresponding to given id ('needle') from a 'haystackObjectArray' with the following format
         *     [
         *         {id:'xyz',value:'pqrs'},{id:'xyzq',value:'pqrst'},{id:'wxyz',value:'opqrs'}...
         *     ]
         * ]
         * @param  {string} needle              ['id' to search for.]
         * @param  {array} haystackObjectArray  [list of key value pairs to search in.]
         * @param  {array} removeDelimiter      [if '--' is to be removed from the start and end of found value.]
         * @param  {String} idKey             [name of the key representing id]
         * @param  {String} valueKey             [name of the key representing value]
         * @return {String}                     [the text of the given needle id]
         */
        utils.getTextFromValue = function(needle, haystackObjectArray, removeDelimiter, idKey, valueKey) {
            var returnValue;
            needle = ko.utils.unwrapObservable(needle);
            returnValue = utils.findInObjectArray(needle, haystackObjectArray, idKey);
            if (returnValue) {
                returnValue = ko.utils.unwrapObservable(returnValue[valueKey]);
            } else {
                returnValue = '';
            }

            if (needle === '' && removeDelimiter) {
                returnValue = returnValue.replace(/--/g, '').trim();
            }

            return returnValue;
        };

        /**
         * to check if a string has unicode character or not
         * @param  {String}  str String to be checked
         * @return {Boolean}     if String has unicode character or not
         */
        utils.hasUnicode = function(str) {
            return !!str.match(/[^\u0000-\u00ff]/);
        };

        /**
         * [allNullArray returns true if all elements of the input array are null]
         * @param  {array} arrayData [the input array]
         * @return {Boolean}         [array all null or not]
         */
        // utils.allEqualElemArray = function(arrayData,elemMatcher) {
        //     return _.every(arrayData,function(elem){
        //         if(elem === elemMatcher){
        //          return true;
        //     }});
        // };

        /**
         * get a image of a string
         * @param  {String} str     String for which image is required
         * @param  {Object} options Properties for the image to be created
         *                          eg: fontSize, fontName, backgroundColor,
         *                              color, mimeType
         * @return {Object}         Object containining src(dataturi), width
         *                          and height of generated image
         */
        utils.getStrImage = function(str, options) {
            var canvas = document.createElement('CANVAS'),
                ctx = canvas.getContext('2d'),
                text = str || '',
                // properties to be used
                props = _.assign({
                    fontSize: 10,
                    fontName: 'MyWebFont',
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    mimeType: 'image/jpeg'
                }, options),
                height, width;
            ctx.font = utils.sformat(
                '{0}px {1}',
                String(props.fontSize),
                props.fontName
            );
            canvas.width = width = ctx.measureText(text).width;
            canvas.height = height = props.fontSize * 1.25;
            ctx.fillStyle = props.backgroundColor;
            ctx.fillRect(0, 0, width, height);
            ctx.fillStyle = props.color;
            ctx.fillText(text, 0, props.fontSize);
            return {
                src: canvas.toDataURL(props.mimeType),
                width: width,
                height: height
            };
        };

        /**
         * to download a file from an Array of Buffer/ArrayBuffer
         * @param  {String}   filename    Name of the file downloaded
         * @param  {Array}    data        Array of Buffer/ArrayBuffer
         * @param  {String}   contentType MIME type of the content
         * @param  {Function} cb          Callback function on success
         * @return {undefined}
         */
        utils.downloadFile = function(filename, data, contentType, cb) {
            var a = document.createElement('a');
            a.style.display = 'none';
            var blob = new Blob(data, {
                type: contentType
            });
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            _.delay(function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                if (_.isFunction(cb)) {
                    cb();
                }
            }, 100);
        };

        /**
         * Gets the property value at `path` of `object`. If the resolved value is
         * `undefined` the `defaultValue` is used in its place.
         *
         * @static
         * @memberOf atn
         * @param {Object} object The object to query.
         * @param {Array|string} path The path of the property to get.
         * @param {*} [defaultValue] The value returned if the resolved value is
         *                           `undefined`.
         * @returns {*} Returns the resolved value.
         * @example
         *
         * var object = { 'a': { 'b': { 'c': 3 } } };
         *
         * _.get(object, 'a.b.c');
         * // => 3
         *
         * _.get(object, ['a', 'b', 'c']);
         * // => 3
         *
         * _.get(object, 'a.b.c', 'default');
         * // => 'default'
         */
        utils.get = function(node, path, defaultValue) {
            var rider = node,
                paths = _.isArray(path) ? path : path.split('.'),
                index = 0;
            while (rider !== undefined && rider !== null && index < paths.length) {
                rider = rider[paths[index++]];
            }
            return index < paths.length ? defaultValue : rider;
        };

        /**
         * redirects the page to the given path.
         * @param  {string}
         * @return {undefined}
         */
        utils.redirect = function(path) {
            window.location.replace(path);
        };

        utils.getBrowserName = function(){
            var name = "Unknown";
            if(navigator.userAgent.indexOf("MSIE")!=-1   || navigator.appVersion.indexOf('Trident/') > 0  ){
                name = "MSIE";
            }
            else if(navigator.userAgent.indexOf("Firefox")!=-1){
                name = "Firefox";
            }
            else if(navigator.userAgent.indexOf("Opera")!=-1){
                name = "Opera";
            }
            else if(navigator.userAgent.indexOf("Chrome") != -1){
                name = "Chrome";
            }
            else if(navigator.userAgent.indexOf("Safari")!=-1){
                name = "Safari";
            }
            return name;   
        };

        return utils;

    });
